import Hours from "@/models/Hours";

export class CumulativeIdleHours extends Hours{
 
}